/* ==========================================================================
   ModalLoading > Client > Config
   ========================================================================== */

/* Modules */
const modalConfig = require('../../../modal/client/js/config');

/* Config */
const config = {
    component: modalConfig().component,
    type: {
        modal: 'modal-loading',
        loading: 'modal-loading-loading'
    },
    css: {
        modal: 'modal--loading'
    }
};

module.exports = () => config;
